import { acceptOnlyValidPayments } from '../payment-input/payment-input-normalize-value';
export const fixedPaymentViewer = {
    normalizeLoadedValue: acceptOnlyValidPayments
};

//# sourceMappingURL=definition-viewer.js.map